import * as DarkReader from 'darkreader';
import axios from 'axios';
import Styled from './styles';
import logger from '/imports/startup/client/logger';
import useMeeting from '../../core/hooks/useMeeting';
import Storage from '/imports/ui/services/storage/session';
// import { getWbCustomApiUrl } from '../../core/utils/getBaseUrl';

const CUSTOM_LOGO_URL_KEY = 'CustomLogoUrl';

const CUSTOM_DARK_LOGO_URL_KEY = 'CustomDarkLogoUrl';

// WARNING: Fallback URLs below point to PRODUCTION. If settings.yml fails to load or
// customUrls is missing, ALL environments (including staging) will silently hit prod.
// Each BBB server's settings.yml MUST define these URLs for its target environment.

export const getLwBackendApiUrl = () => {
  const customUrls = window.meetingClientSettings?.public?.customUrls;
  const webApi = customUrls?.lwBackendApiURL ?? 'https://lessonwise-api-2efcxrdrla-nw.a.run.app';
  return webApi;
};

const getWbCustomApiUrl = () => {
  const customUrls = window.meetingClientSettings?.public?.customUrls;
  const webApi = customUrls?.wbSyncApiURL ?? 'https://lessonwise-api-2efcxrdrla-nw.a.run.app/api/wb-sync';
  return webApi;
};

export const studentLogouturl = () => {
  const customUrls = window.meetingClientSettings?.public?.customUrls;
  const studentlogoutURL = customUrls?.studentLogoutURL ?? 'https://brightpath.lessonwise.org/student/lessons';
  return studentlogoutURL;
};

export const tutorLogouturl = () => {
  const customUrls = window.meetingClientSettings?.public?.customUrls;
  const tutorlogoutURL = customUrls?.tutorLogoutURL ?? 'https://brightpath.lessonwise.org/tutor/lessons';
  return tutorlogoutURL;
};

const equalURLs = () => (
  Storage.getItem(CUSTOM_LOGO_URL_KEY) === Storage.getItem(CUSTOM_DARK_LOGO_URL_KEY)
);
export const saveChatLogApi = (data) => {
  const API_BASE_URL = getLwBackendApiUrl();
  const SAVE_CHAT_LOG_API = `${API_BASE_URL}/wb/save-chat-log`;
  return axios.post(SAVE_CHAT_LOG_API, data);
};
export const fetchCourseDetails = (data) => {
  const API_BASE_URL = getLwBackendApiUrl();
  const COURSE_DETAIL_API = `${API_BASE_URL}/wb/course-user-details-by-internal-meeting-id`;
  return axios.post(COURSE_DETAIL_API, data, { timeout: 10000 });
};
export const validateUser = (data) => {
  const API_BASE_URL = getLwBackendApiUrl();
  const VALIDATE_USER_API = `${API_BASE_URL}/wb/valdiate-user`; // valdiate
  return axios.post(VALIDATE_USER_API, data, { timeout: 10000 });
};
export const logoutUser = (data) => {
  const API_BASE_URL = getLwBackendApiUrl();
  const LOGOUT_USER_API = `${API_BASE_URL}/wb/logout-user`;
  return axios.post(LOGOUT_USER_API, data);
};
export function useMeetingIsBreakout() {
  const { data: meeting } = useMeeting((m) => ({
    isBreakout: m.isBreakout,
  }));

  return meeting && meeting.isBreakout;
}
export const sendFeedbackApi = (data) => {
  const API_BASE_URL = getLwBackendApiUrl();
  const FEEDBACK_API = `${API_BASE_URL}/users/lesson-feedback-new`;
  return axios.post(FEEDBACK_API, data);
};

// IMPORT WHITEBOARD DETAILS ON LOAD COMPONENT
export const importWhiteboardData = (data) => {
  const url = `${getWbCustomApiUrl()}/import`;
  return axios.post(url, data);
};

// EXPORT WHITEBOARD DATA ON SAVE & EXIT
export const exportWhiteboardData = (data) => {
  const url = `${getWbCustomApiUrl()}/export`;
  return axios.post(url, data);
};

// DELETE ANNOTATION
export const deleteWhiboardAnnotations = (data) => {
  const url = `${getWbCustomApiUrl()}/remove-annotation-info`;
  return axios.post(url, data);
};

// UPDATE CURRENT PRESENTATION AND SLIDE
export const updateCurrentStatusPresndPage = (data) => {
  const url = `${getWbCustomApiUrl()}/update-current`;
  return axios.post(url, data);
};

// UPDATE CURRENT PRESENTATION PAGE ZOOM
export const updatePresPageZoom = (data) => {
  const url = `${getWbCustomApiUrl()}/update-pres-page-zoom`;
  return axios.post(url, data);
};

// UPDATE SLIDE DATA ON PAGE CHANGE
export const insertSlideData = (data) => {
  const url = `${getWbCustomApiUrl()}/slides`;
  return axios.post(url, data);
};

// GET ALL SLIDES SVGS
export const getSlidesData = (presentationId) => {
  const url = `${getWbCustomApiUrl()}/slides/${presentationId}`;
  return axios.get(url);
};

// START LIVE SESSION - Transition from prepare mode to live mode
export const startLiveSessionApi = (data) => {
  const API_BASE_URL = getLwBackendApiUrl();
  const START_LIVE_SESSION_API = `${API_BASE_URL}/wb/start-live-session`;
  return axios.post(START_LIVE_SESSION_API, data);
};

// SUBMIT MEET & GREET FEEDBACK - Combined form for parent & student
export const submitMeetGreetFeedbackApi = (data) => {
  const API_BASE_URL = getLwBackendApiUrl();
  const FEEDBACK_API = `${API_BASE_URL}/wb/meet-greet-feedback`;
  return axios.post(FEEDBACK_API, data);
};

// SET DARK THEME COLORS
export const setDarkTheme = (value) => {
  let invert = [Styled.DtfInvert];

  if (equalURLs()) {
    invert = [Styled.DtfBrandingInvert];
  }

  if (value && !DarkReader.isEnabled()) {
    DarkReader.enable(
      { brightness: 100, contrast: 90 },
      {
        invert,
        ignoreInlineStyle: [Styled.DtfCss],
        ignoreImageAnalysis: [Styled.DtfImages],
      },
    );
    logger.info({ logCode: 'dark_mode' }, 'Dark mode is on.');

    window.dispatchEvent(new CustomEvent('darkmodechange', { detail: { enabled: true } }));
  }

  if (!value && DarkReader.isEnabled()) {
    DarkReader.disable();
    logger.info({ logCode: 'dark_mode' }, 'Dark mode is off.');

    window.dispatchEvent(new CustomEvent('darkmodechange', { detail: { enabled: false } }));
  }
};

export const isDarkThemeEnabled = () => DarkReader.isEnabled();

export default {
  setDarkTheme,
  isDarkThemeEnabled,
  useMeetingIsBreakout,
};
